module.exports = new __parcel__URL__("NWBrickCon.17492363.webp").toString();